import { DropDownCategories } from 'src/types/generic';

export interface SearchPriceRangeOption {
  value: string;
  label: string;
}

export const SearchPriceRanges: SearchPriceRangeOption[] = [
  { value: '', label: 'Select Price Range' },
  { value: 'under25', label: 'Under $25' },
  { value: '25to50', label: '$25 to $50' },
  { value: '50to100', label: '$50 to $100' },
  { value: '100to200', label: '$100 to $200' },
  { value: 'over200', label: 'Over $200' },
];

export const SearchItemFilterCategories: DropDownCategories[] = [
  { value: 0, label: 'All Items' },
  { value: 1, label: 'Only Contracted Items' },
];
